// extracted by mini-css-extract-plugin
export default {"terminal_screen":"styles_terminal_screen__v9w3S"};